import React from "react";

import BonusPoint from "./../bonuspoint/bonuspoint";
import TwoBox from "./../twopoint/twopoint";
import HomeBanner from "./../homebanner/homebanner";
import RewardsWrapper from "./../rewardswrapper/rewardswrapper";
import homeData from "./../../data/home.json";
import dashboardData from "./../../data/dashboard.json";
import RewardsDashboard from "../dashboard/dashboard";
import GetRewarded from "../getRewarded/getRewarded";
import RedeemRewards from "../redeemRewards/redeemRewards";
import { useStoreState } from "easy-peasy";
import RewardsCarousel from "../rewardsCarousel/rewardsCarousel";
import Disclosure from "../disclosure/disclosure";
import PromotionBanner from "../promotionalBanner/promotionalBanner";

const Home = (props) => {
  document.title = props.title;
  const getUserValue = useStoreState((state) => state.user.userInfo); 

  const legalParagraphs = [
    `When you pay your monthly wireless bill with your eligible PNC Visa credit card, your cell phone is protected for the next calendar month if it is stolen or damaged. A maximum of 2 claims will be paid each 12-month period, with each claim subject to a $50 deductible. Additional terms, conditions and exclusions apply. See your <a href="https://www.pnc.com/en/personal-banking/banking/credit-cards/benefits/pnc-visa.html" target="_blank" rel="noopener noreferrer">Visa Guide to Benefits</a> for complete program details.`,
    `All points expire at the end of the month, 48 months after they were added to your PNC points account. See our <a href="https://www.pnc.com/en/personal-banking/banking/rewards/pnc-purchase-payback.html" target="_blank" rel="noopener noreferrer">PNC Purchase Payback</a> guide for complete program details.`
  ]

  return (
    <>
      {getUserValue ? ( 
        // Show this if user is authenticated
        <>
        <PromotionBanner
            userValue={getUserValue}
            catalogUrl={global.catalogUrl}
            promotions={[
              { startDate: "01/01/2025, 12:01:00 AM", endDate: "02/18/2025, 11:59:00 PM", imgClass: "PNC_040125_Front_Porch_Banner_360x55_High", promoUrl: 'GiftCard&shop=FuelUp25'},
              { startDate: "02/19/2025, 12:01:00 AM", endDate: "03/31/2025, 11:59:00 PM", imgClass: "PNC_040125_Front_Porch_Banner_360x55_High", promoUrl: 'GiftCard&shop=AprilGC'},
              { startDate: "04/01/2025, 12:01:00 AM", endDate: "04/30/2025, 11:59:00 PM", imgClass: "PNC_050125_Front_Porch_Points_Banner_960x155", promoUrl: 'GiftCard&shop=MayGC'},
              { startDate: "05/01/2025, 12:01:00 AM", endDate: "06/01/2025, 11:59:00 PM", imgClass: "PNC_050125_Front_Porch_Points_Banner_960x155", promoUrl: 'GiftCard&shop=MayGC'},
              { startDate: "06/02/2025, 12:01:00 AM", endDate: "06/23/2025, 11:59:00 PM", imgClass: "PNC_060225_FrontPorchBanner_High_960x155", promoUrl: 'GiftCard'},
              { startDate: "07/08/2025, 12:01:00 AM", endDate: "07/31/2025, 11:59:00 PM", imgClass: "", promoUrl: 'gift'},
              { startDate: "08/01/2025, 12:01:00 AM", endDate: "09/03/2025, 11:59:00 PM", imgClass: "", promoUrl: 'gift'},
              { startDate: "09/04/2025, 12:01:00 AM", endDate: "09/30/2025, 11:59:00 PM", imgClass: "", promoUrl: 'gift'},
              { startDate: "10/01/2025, 12:01:00 AM", endDate: "11/04/2025, 11:59:00 PM", imgClass: "", promoUrl: 'gift'},
              { startDate: "11/05/2025, 12:01:00 AM", endDate: "12/18/2025, 11:59:00 PM", imgClass: "", promoUrl: 'gift'},
            ]}
          />

          <RewardsDashboard
            dashboardData={dashboardData.dashboardData}
          />
          <RewardsCarousel />
          <RedeemRewards />
          <GetRewarded />
          <Disclosure content={legalParagraphs}/>
        </>
      ) : (
        // Show this if user is not authenticated
        <>
          <HomeBanner homeBanner={homeData.homeBanner} />
          <TwoBox boxData={homeData.boxData} />
          <BonusPoint />
          <RewardsWrapper rewards={homeData.rewards} />
          <Disclosure/>
        </>
      )}
    </>
  );
};

export default Home;
